/**
 * Tumbodash player identity color pool.
 *
 * Single source of truth — imported by:
 *   - backend (via @tumbodash/nodePackages)    → pool assignment on party join
 *   - game-engine (via @tumbodash/browserPackages) → Phaser rendering
 *   - frontend (via @tumbodash/browserPackages)    → lobby/roster UI
 *
 * Add or reorder colors here and every consumer updates automatically.
 */
export const PLAYER_COLORS = [
	{ hex: "#4ec9b7", phaser: 0x4ec9b7 }, // teal
	{ hex: "#4a8fe8", phaser: 0x4a8fe8 }, // blue
	{ hex: "#ff6b6b", phaser: 0xff6b6b }, // coral
	{ hex: "#a07ad4", phaser: 0xa07ad4 }, // purple
	{ hex: "#4ec97a", phaser: 0x4ec97a }, // green
	{ hex: "#f09048", phaser: 0xf09048 }, // orange
	{ hex: "#f06090", phaser: 0xf06090 }, // pink
	{ hex: "#c8c84a", phaser: 0xc8c84a }, // olive
] as const;

export type PlayerColor = (typeof PLAYER_COLORS)[number];

/** All hex strings as a plain array — convenient for pool-based assignment. */
export const PLAYER_COLOR_HEX = PLAYER_COLORS.map(c => c.hex);

/** Convert a player hex color string (e.g. "#ff6b6b") to a Phaser integer (0xff6b6b). */
export function hexToPhaser(hex: string): number {
	return parseInt(hex.replace("#", ""), 16);
}
